import { Component, OnInit } from '@angular/core';
import { Servidor } from '../_classes/servidor';
import { Observable, Subject, timer, EMPTY } from 'rxjs';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import { RestService } from '../_servicos/rest.service';
import { take } from 'rxjs/operators';
import { EnvService } from '../_servicos/env.service';

@Component({
  selector: 'app-caixa-entrada-email',
  templateUrl: './caixa-entrada-email.component.html',
  styleUrls: ['./caixa-entrada-email.component.scss'],
})
export class CaixaEntradaEmailComponent implements OnInit {
  carregando = false;
  mostrarSolicicaoSenha: boolean = false;
  ramal = '';

  servidor: Servidor;
  servidor$: Observable<Servidor>;
  dataSource$: Observable<number>;
  total: number = 0;

  emailSemSenha = false;
  conexaoOk = false;

  mostrarAjuda = false;
  erros$ = new Subject<boolean>();
  erros: number = 0;

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private alertService: ModalAlertaService,
    private env: EnvService,
    private service: RestService
  ) {}

  ngOnInit() {
    this.atualizar();
  }

  handleError(e: any) {
    //console.log(e);
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro ao incluir ramal, tente novamente',
      e
    );
  }

  atualizar() {
    //console.log('carregando = true e conexaoOk = false');
    this.conexaoOk = false;
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    this.servidor = this.env.servidor;

    if (this.servidor.usuario.dsSenha) {
      this.emailSemSenha = false;
      //console.log('vou buscar emails');

      if (this.servidor) {
        //console.log('this.servidor.usuario - ANTES', this.servidor.usuario);
        this.servidor.usuario.dsSenha = btoa(this.servidor.usuario.dsSenha);
        //console.log('this.servidor.usuario - DEPOIS', this.servidor.usuario);
        this.dataSource$ = this.service
          .getQuantidadeEmailsNaoLidos(this.servidor.usuario)
          .pipe(take(1));

        this.dataSource$.subscribe(
          (a: number) => {
            this.conexaoOk = true;
            //console.log('busca de emails - retorno', a);
            this.total = a;
            this.carregando = false;
          },
          (e) => {
            //this.erros++;
            //this.handleError(e);
            return EMPTY;
          }
        );
      }
    } else {
      this.emailSemSenha = true;
      //console.log('não vou buscar emails - senha em branco');
    }

    this.carregando = false;
  }
}
